import { EMediaType } from '../../components/NewbuildingTiledCarousel/FullscreenGallery';
import {
  EVideoResolution,
  getVideoPreviewUrl,
} from '../../components/NewbuildingTiledCarousel/FullscreenGallery/utils/getVideoPreviewUrl';
import { IVideoSchema } from '../../repositories/offer-card/entities/video/VideoSchema';
import { IMediaItem } from '../../types/newbuildingTiledCarousel';

export const mapOfferDataToNewbuildingGalleryVideo = (offerVideos: IVideoSchema[]): IMediaItem[] => {
  const videos = offerVideos.map((item, i) => ({
    alt: '',
    fullUrl: '',
    id: i,
    polygonPath: null,
    isPrimaryImage: false,
    mediaType: EMediaType.Video,
    thumbnailUrl: getVideoPreviewUrl(item.id as string, EVideoResolution.HQ),
    videoUrl: item.url,
  }));

  return videos;
};
